import React from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Tabs } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

const Navigation = ({ selectedDashboard }) => {
  const {
    manageAccount: { manageControlTabs }
  } = useLocalizedStringsContext();
  const history = useHistory();

  const tabItems = manageControlTabs.map(({ key, label }) => ({
    id: key,
    label
  }));

  return (
    <Tabs
      value={selectedDashboard}
      onChange={(tabId) => history.push(`/manage-control/${tabId}`)}
      items={tabItems}
      itemTokens={{ maxWidth: 'none', borderWidth: 1, borderColor: '#D8D8D8', marginHorizontal: 75 }}
    />
  );
};

Navigation.propTypes = {
  selectedDashboard: PropTypes.string.isRequired
};

export default Navigation;
